// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type GetUserMenuQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetUserMenuQuery = { __typename?: 'Query' } & {
  currentEmployee: { __typename?: 'CurrentEmployee' } & {
    employee: { __typename?: 'Employee' } & {
      performanceReviews: Array<
        { __typename?: 'PerformanceReview' } & Pick<Types.PerformanceReview, 'id'> & {
            period: { __typename?: 'PerformanceReviewPeriod' } & Pick<
              Types.PerformanceReviewPeriod,
              'year' | 'quarter' | 'isCurrent'
            >;
          }
      >;
    };
  };
};

export const GetUserMenuDocument = /*#__PURE__*/ gql`
    query getUserMenu {
  currentEmployee {
    employee {
      performanceReviews(isRecentOnly: true) {
        id
        period {
          year
          quarter
          isCurrent
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserMenuQuery__
 *
 * To run a query within a React component, call `useGetUserMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserMenuQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserMenuQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUserMenuQuery, GetUserMenuQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserMenuQuery, GetUserMenuQueryVariables>(GetUserMenuDocument, options);
}
export function useGetUserMenuLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserMenuQuery, GetUserMenuQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserMenuQuery, GetUserMenuQueryVariables>(GetUserMenuDocument, options);
}
// @ts-expect-error
export function useGetUserMenuSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserMenuQuery, GetUserMenuQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserMenuQuery, GetUserMenuQueryVariables>;
export function useGetUserMenuSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserMenuQuery, GetUserMenuQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserMenuQuery | undefined, GetUserMenuQueryVariables>;
export function useGetUserMenuSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserMenuQuery, GetUserMenuQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserMenuQuery, GetUserMenuQueryVariables>(GetUserMenuDocument, options);
}
export type GetUserMenuQueryHookResult = ReturnType<typeof useGetUserMenuQuery>;
export type GetUserMenuLazyQueryHookResult = ReturnType<typeof useGetUserMenuLazyQuery>;
export type GetUserMenuSuspenseQueryHookResult = ReturnType<typeof useGetUserMenuSuspenseQuery>;
